import React from 'react';
import { StyledTable } from '../../components/Antd/StyledTable';
import {OrganizationItem, Script} from '../../types';
import { TableProps } from 'antd';
import { DropDown } from './DropDown';
import {OrganizationTags} from "../../components/OrganizationTags";

interface Props {
  tableData: Script[];
  loading: boolean;
  onRemove: (scriptId: string) => void;
}

export const ScriptsTable: React.FunctionComponent<Props> = ({ tableData, loading, onRemove }) => {
  const tableColumns: TableProps<Script>['columns'] = [
    {
      title: 'Name',
      dataIndex: 'script_name',
      key: 'script_name',
      className: 'extrabold-14',
      width: '50%',
      ellipsis: true
    },
    {
      title: 'Organization',
      dataIndex: 'organizations',
      key: 'organizations',
      width: '32%',
      render: (organizations: OrganizationItem[]) => <OrganizationTags organizations={organizations} />
    },
    {
      title: ' ',
      key: 'menu',
      width: '8%',
      align: 'center',
      render: (value, script) => <DropDown script={script} onRemove={onRemove} />
    }
  ];

  return (
    <StyledTable
      columns={tableColumns}
      dataSource={tableData}
      rowKey="script_id"
      loading={loading}
      pagination={false}
      scroll={{ y: 'calc(100vh - 390px)', x: 300 }}
      showSorterTooltip={false}
    />
  );
};
